import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Downtime } from '../../../../core/services/times/downtime';

@Component({
  selector: 'app-ai-window',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions],
  templateUrl: './ai-window.html',
  styleUrl: './ai-window.scss'
})
export class AiWindow implements OnInit{
  readonly dialogRef = inject(MatDialogRef<AiWindow>);
  data = inject(MAT_DIALOG_DATA);
  downtime = inject(Downtime);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  clickIconClose(event: MouseEvent){
      this.onNoClick();
  }

  onNoClick(): void {
    this.downtime.refreshTimer();
    this.dialogRef.close();
  }

}
